import { PageHeader, PageHeaderProps } from '../components/PageHeader'
import {
  CountryDropdown,
  CountryDropdownProps,
  DatePicker,
  DatePickerProps,
} from '../components/ResultFilterBar'

import styles from './LottoResultScreen.module.css'

interface LottoResultScreenProps {
  pageHeaderProps: PageHeaderProps
  countryDropdownProps: CountryDropdownProps
  datePickerProps: DatePickerProps
  children: React.ReactNode
}

export const LottoResultScreen = ({
  pageHeaderProps,
  countryDropdownProps,
  datePickerProps,
  children,
}: LottoResultScreenProps) => {
  return (
    <div className="w-full">
      <PageHeader {...pageHeaderProps} />

      <div
        className={`flex bg-[var(--bg-secondary)] mb-6 sm:mb-12 justify-center ${styles.filterContainer}`}
      >
        {/* Filters */}
        <div className="flex gap-3 sm:mt-0">
          <CountryDropdown {...countryDropdownProps} />
          <DatePicker {...datePickerProps} />
        </div>
      </div>
      <div className={`${styles.resultsContainer} space-y-4 sm:space-y-12`}>
        {children}
      </div>
    </div>
  )
}
